import React, { useState } from 'react';
import { SxProps, Theme } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';
import { isForbiddenError } from '@domain/base/ApiError';
import { UpdateSubscriptionDialog } from '@features/subscription/components/ui/plans/UpdateSubscriptionDialog';
import EmptyState from './EmptyState';
import UpgradeRequiredState from './UpgradeRequiredState';

interface ErrorStateProps {
  error?: unknown;
  sx?: SxProps<Theme>;
}

const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error && error.message) {
    return error.message;
  }
  if (typeof error === 'string' && error.length > 0) {
    return error;
  }
  return 'We could not load this data. Please try again.';
};

const ErrorState: React.FC<ErrorStateProps> = ({ error, sx }) => {
  const [planSelectOpen, setPlanSelectOpen] = useState(false);

  if (isForbiddenError(error)) {
    return (
      <>
        <UpgradeRequiredState onUpgrade={() => setPlanSelectOpen(true)} />
        <UpdateSubscriptionDialog
          open={planSelectOpen}
          onClose={() => setPlanSelectOpen(false)}
        />
      </>
    );
  }

  return (
    <EmptyState
      title="Something went wrong"
      description={getErrorMessage(error)}
      icon={ErrorOutline}
      sx={sx}
    />
  );
};

export default ErrorState;
